import React from "react";
import Allnews from "../components/News/Allnews";
const News = () => {
  return (
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
      <Allnews />
    </div>
  );
};

export default News;
